<script>
import {useToast} from "vue-toastification";
import {debounce} from 'lodash';
import assetMaterialsHelper from "@/mixins/assetMaterialsHelper";

export default {
  mixins: [
    assetMaterialsHelper
  ],
  props: [
    'modelValue',
  ],
  emits: ['update:modelValue'],
  async mounted() {
    // Set default value
    this.dialogUsers = this.dialogUsersDefault;
    // Setup toast
    this.toast = useToast()
    // Get CSRF token
    await this.requestGetCSRFtoken();
  },
  data () {
    return {
      toast: null,
      userCSRFToken: '',
      assetTypes: [],
      dialogLoading: false,
      dialogPage: 1,
      dialogUsers: {},
      dialogFilters: {
        roles: 'mechanic',
        name: '',
      },
      dialogUsersDefault: {
        rows: [],
        pager: {
          total_pages: 0,
          total_items: 0,
          items_per_page: 10,
        },
      },
      userRoles: [
        {
          title: 'Alle',
          value: 'All',
        },
        {
          title: 'Monteur',
          value: 'mechanic',
        },
        {
          title: 'Aannemer',
          value: 'contractor',
        },
        {
          title: 'Beheerder',
          value: 'client_manager',
        }
      ],
    }
  },
  computed: {
    dialogHeaders() {
      // Set default headers
      return [
        {
          title: 'Selecteer',
          key: 'select_user',
          sortable: false,
        },
        {
          title: 'Gebruikersnaam',
          align: 'start',
          key: 'name',
          sortable: true,
        },
        {
          title: 'Rollen',
          align: 'start',
          key: 'roles',
          sortable: true,
        },
        {
          title: 'Organisatie',
          align: 'start',
          key: 'organisation',
          sortable: false,
        },
      ];
    },
    pageCount () {
      return parseInt(this.dialogUsers.pager.total_pages);
    },
    dialogTotalItems () {
      return parseInt(this.dialogUsers.pager.total_items);
    },
    dialogItemsPerPage () {
      return parseInt(this.dialogUsers.pager.items_per_page);
    }
  },
  methods: {
    closeDialog() {
      // Reset to default value
      this.dialogUsers = this.dialogUsersDefault;
      // Emit event
      this.$emit('dialog-closed')
    },
    selectUser(user) {
      // Emit event
      this.$emit('user-selected', {selected_user: user})
    },
    usersUpdateOptions({ page, itemsPerPage, sortBy }) {
      if (this.modelValue) {
        if (page) {
          this.dialogPage = page;
        }

        if (sortBy && sortBy.length > 0) {
         this.sortBy = sortBy[0];
        }

        this.requestGetUsers();
      }
    },
    requestGetUsers: debounce(async function () {
      this.dialogLoading = true;
      let url = import.meta.env.VITE_API_BASEURL + 'api/select-user/';
      let params = {
        page: this.dialogPage - 1,
        roles: 'All',
        name: '',
        sort_by: 'name',
        sort_order: 'ASC',
      }

      if (this.sortBy) {
        params.sort_by = this.sortBy.key;
        params.sort_order = this.sortBy.order.toUpperCase();
      }

      if (this.dialogFilters.name.length > 0) {
        params.name = this.dialogFilters.name;
      }
      if (this.dialogFilters.roles.length > 0) {
        params.roles = this.dialogFilters.roles;
      }

      // Fetch session token
      const response = await fetch(url + '?' + new URLSearchParams(params), {
        credentials: "include"
      })
      const response_json = await response.json();
      // Set users
      this.dialogUsers = response_json;
      this.dialogLoading = false;
    }, 400),
  },
}
</script>

<template>

  <v-dialog
    :model-value="modelValue"
    @click:outside="closeDialog()"
    width="800"
  >
    <v-card>
      <v-card-title>
        <div class="d-flex justify-space-between">
          Selecteer gebruikers
          <v-btn icon="mdi-close" size="small" @click="closeDialog()"></v-btn>
        </div>
      </v-card-title>
      <v-card-text>

        <!-- TODO: Add table sort and filters. See usersUpdateOptions() to add sort. Also add 'sort: true' on the this.dialogHeaders array. -->

        <v-data-table-server
          class="users"
          :headers="dialogHeaders"
          :items="dialogUsers.rows"
          :items-per-page="dialogItemsPerPage"
          :items-length="dialogTotalItems"
          item-value="name"
          :items-per-page-options="[{value: 10, title: '10'}]"
          height="550"
          no-data-text="Geen gebruikers gevonden (met deze filters). Dit kan ook te maken hebben met uw rol, of het missen van gekoppelde aannemers/monteurs."
          loading-text="Laden.."
          :loading="dialogLoading"
          @update:options="usersUpdateOptions"
        >
          <template v-slot:thead>
            <!-- Loop over all header items -->
            <tr>
              <th v-for="header in dialogHeaders" :key="header.key">
                <template v-if="header.key === 'name'">
                  <v-text-field
                    v-model.lazy="dialogFilters.name"
                    debounce
                    density="compact"
                    placeholder="Zoek gebruikersnaam..."
                    hide-details
                    @update:model-value="usersUpdateOptions"></v-text-field>
                </template>
                <template v-else-if="header.key === 'roles'">
                  <v-select
                    v-model.lazy="dialogFilters.roles"
                    :items="userRoles"
                    default-value="mechanic"
                    density="compact"
                    placeholder="Filter roles"
                    hide-details
                    @update:model-value="usersUpdateOptions"></v-select>
                </template>
              </th>
            </tr>
          </template>
          <template #item.select_user="{ item }">
            <v-btn @click="selectUser(item)" variant="text" color="primary">
              Selecteer
            </v-btn>
          </template>
        </v-data-table-server>

      </v-card-text>
    </v-card>
  </v-dialog>

</template>

<style lang="scss">
.users {
  table {
    margin: 0;
  }
  .v-data-table-footer__items-per-page {
    display: none;
  }
}
</style>
